<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"  
        v-on="on"
      >
        Create Payroll Period
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Period"
      text="Create payroll period"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="7">
              <v-data-table
                v-model="selectedCompanies"
                v-validate="'required'"
                :items="filteredCompanies"
                disable-pagination
                :error-messages="errors.collect('selectedCompanies')"
                data-vv-name="selectedCompanies"
                data-vv-as="payroll companies"
                hide-default-footer
                show-select
                dense
                :headers="headers"
                item-key="id"
                item-value="id"
                :height="tableHeight"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-toolbar-title class="pa-0">
                      Payroll Companies:
                    </v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
              <span class="red--text text--lighten-1 caption">{{ errors.first('selectedCompanies') }}</span>
            </v-col>

            <v-divider vertical />

            <v-col>
              <v-text-field
                v-model="searchInput"
                placeholder="Filter company by name"
                append-icon="search"
                label="Search Company"
                hide-no-data
                hide-selected
              />
           
              <p
                class="font-weight-bold my-3"
                style="font-size:large !important"
              >
                Payroll Period : {{ $moment(payrollPeriod + '-01').format('MMM YYYY') }}
              </p>

              <v-autocomplete
                v-model="payrollCycle" 
                v-validate="'required'"
                :error-messages="errors.collect('payrollCycle')"    
                data-vv-name="payrollCycle" 
                data-vv-as="payroll cycle"
                label="Payroll Cycle"
                :items="payrollCycles"
                :item-text="item => '['+item.code+'] - '+ item.name"
                item-value="id"
              />
            </v-col>
          </v-row>
        </v-container>
      </form> 
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriod: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        payrollCycles: [],
        companies: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'name',
          },
        ],
        selectedCompanies: [],
        searchInput: '',
        payrollCycle: null,
      }
    },
    computed: {
      filteredCompanies () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        return this.companies.filter(function (company) {
          return company.name.toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1 
        })
      },

      tableHeight () {
        if (this.companies.length <= 2) return '100px'

        if (this.companies.length <= 6) return '200px'

        if (this.companies.length <= 10) return '300px'

        if (this.companies.length <= 14) return '400px'

        return '500px'
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return 

        this.loading = true

        Promise.all([
          this.$api.hrisPayrollCycles().list(),
          this.$api.hrisCompanies().list('?filter_by=organization'),
        ])
          .then(([payrollCycle, company]) => {
            this.payrollCycles = _.orderBy(payrollCycle.data, ['code'], ['asc'])  
            this.companies = _.orderBy(company.data, ['name'], ['asc'])  
            
            this.loading = false
          })
      },
    },

    methods: { 
      prepareFormData () {
        return {
          payroll_date: this.payrollPeriod + '-01',
          payroll_cycle_id: this.payrollCycle,
          selected_payroll_companies: this.selectedCompanies.map(company => { return company.id }),
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.payrollPeriods().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      openDialog () {
        this.dialog = true
      },
    },
  }
</script>
